import { render } from "./RecommendationPersonas.vue?vue&type=template&id=8b44eba4&scoped=true"
import script from "./RecommendationPersonas.vue?vue&type=script&lang=js"
export * from "./RecommendationPersonas.vue?vue&type=script&lang=js"

import "./RecommendationPersonas.vue?vue&type=style&index=0&id=8b44eba4&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8b44eba4"]])

export default __exports__